import contributors from '../../assets/cms/contributors.json';

export function getContributor(tagOrId) {
	// IDs start with a number (the number at the start is the timestamp of their creation)
  if (!isNaN(tagOrId[0])) {
		return contributors[tagOrId];
	// Tags cannot start with a number
  } else {
    return [...Object.values(contributors)].find(contributor => contributor.tag === tagOrId);
  }
}
